import script from "./ProfileTopicComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileTopicComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileTopicComponent.vue?vue&type=style&index=0&id=2d2c4d00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2c4d00"]])

export default __exports__